import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2acfc43b&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2acfc43b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acfc43b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2acfc43b')) {
      api.createRecord('2acfc43b', component.options)
    } else {
      api.reload('2acfc43b', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2acfc43b&scoped=true&", function () {
      api.rerender('2acfc43b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8ap0nRE47DMPe/JS/teamMember.vue"
export default component.exports